import {Expose} from "class-transformer";
import {CommandPayload} from "./command-payload";

/**
 * Payload of `SaveTenantThemeCommand` (feature plan 0054): the whole tenant theme stylesheet. The
 * backend handler reads `css`; it is validated in the editor and again on the server.
 */
export class TenantThemeContent extends CommandPayload {

    @Expose()
    public css: string;

    public constructor(css: string) {
        super();
        this.css = css;
    }
}
